import { NavigateOptions, useNavigate } from "react-router-dom";
import { useRouting } from "./with-routing";

const usePathNavigate = () => {
	const navigate = useNavigate();
	const createPath = useRouting.use.createPath();

	return (path: string, options?: NavigateOptions) => navigate(createPath(path), options);
};

export default usePathNavigate;